<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.marka_bildirimi"  url="BrandNotifications" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">

<div class="col-12 ">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12">
<InputSwitchValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>


<div class="col-12 ">
<InputCalendarValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputCalendarValidate>
</div>

<!-- if select-->

<div class="col-12 " v-for="item in translations">
<h4 class="text-primary">{{item.language.name}} çevirisi</h4>
<ClickEditInputText  title="Başlık" :value="item.title" valkey="title" @dataChanged="dataChanged($event,item.language.id)" />

<ClickEditInputRichTextArea  title="Özet" :value="item.excerpt" valkey="excerpt" @dataChanged="dataChanged($event,item.language.id)" />


<ClickEditInputRichTextArea  title="Metin" :value="item.message" valkey="message" @dataChanged="dataChanged($event,item.language.id,)" />

</div>



<div class="col-12 md:col-6">
<h4 class="text-primary">Bildirim Gönderilecek Tedarikçiler</h4>
</div>




<div class="col-12 md:col-6 mt-3">

<div class="grid">
<div class="col-9">
<AutoComplete 
v-model="selectedSupplier" 
optionLabel="name" 
:suggestions="suggestedSuppliers" 
@complete="searchSupplier" 
@item-select="itemSelected"
class="w-full p-inputtext-sm "
placeholder="Tedarikçi isim ya da kodu ile ara"
>
<template #item="slotProps">
   {{slotProps.item.name}} - {{slotProps.item.suppliercode}} 
</template>
</AutoComplete>
</div>

<div class="col-3">
<Button 
:label="$store.state.languages.lang_phrases.toplu_yukle" 
class="p-button-primary p-button-outlined  p-button-sm " 
@click="openUploadModal" 
></Button>
</div>
</div>

  
</div>

<div class="col-12"><hr></div>





</div>








<ScrollPanel style="width: 100%; height: 400px">
<DataTable 
:value="selectedSuppliers" 
:lazy="true" 
class="p-datatable-suppliers" 
dataKey="id" 
:rowHover="true" 
filterDisplay="menu"  
responsiveLayout="scroll"
>

<Column field="name" :header="$store.state.languages.lang_phrases.isim"  style="min-width: 15rem;max-width:20rem">
  <template #body="{data}">
      <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.id}}">{{data.name}}</router-link>
  </template>
 
</Column>

<Column field="suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu"  style="min-width: 15rem;max-width:20rem">
  <template #body="{data}">
      <p>{{data.suppliercode}}</p>
  </template>
 
</Column>
<Column  header="" >
  <template #body="{data}">
      <Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="removeFromList(data.id)" ></Button>
  </template>
    
  </Column>

</DataTable>
</ScrollPanel>





<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>
</template>
<NotificationUploader @listUpdated="listUpdated" ref="uploader"/>
</div>
</template>
<script>
import NotificationUploader from "./NotificationUploader"
export default {

  name: 'CreateBrandNotification',

  data () {
    return {
    	loading:true, 
    	languages:[],
      suppliers:[],
      selectedSupplier:null,
      selectedSuppliers:[],
      suggestedSuppliers:[],
    	fields:[
	      {
	        title:"İsim",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },	      
       	  {
	        title:"Dashboardda Göster",
	        key:"show_on_dashboard",
	        type:"switch",
	        value:null,
	        is_required:false,
	        show:true,
	      },
	      {
	        title:"Geçerlilik Tarihi",
	        key:"valid_until",
	        type:"date",
	        value:null,
	        is_required:false,
	        show:false,
	      },
      ],
      translations:[],
    }
  },
  components:{NotificationUploader},
  computed:{
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:
  {
    preflang_id()
    {
      setTimeout(()=>{
        this.fields[0].title = this.$store.state.languages.lang_phrases.isim
        this.fields[1].title = this.$store.state.languages.lang_phrases.periyodik
        this.fields[2].title = this.$store.state.languages.lang_phrases.baslangic_tarihi
      },500)
      
    }
  },
  async mounted()
  {
  	this.languages = await this.generalApiGetWithoutLoader("languages") 
    //this.suppliers = await this.generalApiGetWithoutLoader("brand/all_suppliers/"+this.$route.params.id) 
  	for(let language of this.languages)
  	{
  		this.translations.push({
  			language:language,
  			title:null,
  			excerpt:null,
  			message:null,
  		})
  	}
  	this.loading = false
  	
  },
  methods:{
    removeFromList(id)
    {
      this.selectedSuppliers = this.selectedSuppliers.filter(item=>item.id !==id)
    },
    openUploadModal()
    {
      this.$store.dispatch('brands/setNotificationUploader',true) 
    },
    itemSelected(data)
    {
      console.log("itemSelected")
      console.log(data)
      let item = this.sanitizeArray(this.selectedSupplier)
      if(item.projectsuppliers)
      {
        delete item.projectsuppliers
      }
      
      let ind = this.selectedSuppliers.findIndex(element=>element.id == item.id)
      if(ind == -1)
      {
        this.selectedSuppliers.push(item)
      }
      this.selectedSupplier = null
    },
    async searchSupplier(event)
    {
      let searchterm = await event.query.toUpperCase();
      let data = await this.generalApiGetWithoutLoader("brand/suppliers/"+this.$route.params.id+"/0/10?search="+searchterm)
      console.log(data)
      this.suggestedSuppliers = data.data
    },
  	dataChanged(data,id)
  	{
  		console.log(data)
  		let translation = this.translations.findIndex((item)=>{return item.language.id == id})
  		console.log(translation)
  		this.translations[translation][data.key] = data.value
  		console.log(this.translations[translation])
  	},
  	submitForm()
    {

        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false   
      if(data.index==1)  
      {
      	if(data.value)
      	{
      		this.fields[2].show = true
      	}
      	else
      	{
      		this.fields[2].show = false
      	}
      }
    },
    submit()
    { 
      if(!this.selectedSuppliers.length)
      {
        this.showMessage("error","Lütfen en az bir tedarikçi seçin.","")
        return false
      }
      
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log(formdata)
      formdata.append("translations",JSON.stringify(this.translations)) 
      formdata.append("selected_suppliers",JSON.stringify(this.selectedSuppliers.map((item)=>{return item.id})))    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"brand/store_brand_notification/"+this.$route.params.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response)        
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        } 
        else
        {
        	this.$router.push({ name: 'BrandNotification', params: { id:this.$route.params.id,notification_id: response.data.id} })
        }
      
    },
    listUpdated(data)
    {
      console.log("listUpdated")
      console.log(data)
      for(let item of data)
      {
        let ind = this.selectedSuppliers.findIndex(element=>element.id == item.id)
        if(ind == -1)
        {
          this.selectedSuppliers.push(item)
        }
      }

      setTimeout(()=>{
        this.$refs.uploader.close()
      },50)
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>